import { createSelector } from 'reselect';
import { SOCKET_STATUS } from './socket.types';

const selectSocketState = (state) => state.socket;

export const selectSocketStatus = (namespace) => createSelector(
    [selectSocketState],
    (socket) => socket[namespace].status,
);

export const selectIsSocketHealthy = (namespace) => createSelector(
    [selectSocketStatus(namespace)],
    (status) => status === SOCKET_STATUS.CONNECTED,
);

export const selectIsAnySocketReconnecting = createSelector(
    [selectSocketState],
    (socket) => (
        socket.notifications.status === SOCKET_STATUS.RECONNECTING ||
        socket.collaboration.status === SOCKET_STATUS.RECONNECTING
    ),
);

export const selectIsAnySocketDisconnected = createSelector(
    [selectSocketState],
    (socket) => (
        socket.notifications.status === SOCKET_STATUS.DISCONNECTED ||
        socket.collaboration.status === SOCKET_STATUS.DISCONNECTED
    ),
);
